'use client';

import React from 'react';

interface ClockStatusCardProps {
  status: 'clocked_in' | 'clocked_out';
  currentTime: string;
}

export default function ClockStatusCard({ status, currentTime }: ClockStatusCardProps) {
  const isClockedIn = status === 'clocked_in';

  return (
    <div className={`card-phone p-5 border-2 transition-all duration-500 ${
      isClockedIn
        ? 'border-primary border-opacity-30' :'border-border'
    }`}>
      <div className="flex items-center justify-between mb-3">
        <p className="text-xs font-semibold text-muted-foreground uppercase tracking-widest">
          Current Status
        </p>
        <span className={`px-2.5 py-1 rounded-full text-xs font-bold tracking-wide ${
          isClockedIn
            ? 'bg-blue-50 text-primary border border-blue-200' :'bg-amber-50 text-amber-700 border border-amber-200'
        }`}>
          {isClockedIn ? '● CLOCKED IN' : '○ NOT CLOCKED IN'}
        </span>
      </div>

      <div className="flex items-end justify-between">
        <div>
          <p className="text-3xl font-bold text-foreground tabular-nums">
            {isClockedIn ? 'Working' : 'Off Clock'}
          </p>
          <p className="text-sm text-muted-foreground mt-1">
            {isClockedIn ? 'Your session is active' : 'No active session'}
          </p>
        </div>
        <div className="text-right">
          <p className="text-xs text-muted-foreground mb-0.5">Server time</p>
          <p className="text-base font-bold text-foreground tabular-nums">{currentTime}</p>
          <p className="text-xs text-muted-foreground">America/New_York</p>
        </div>
      </div>

      {isClockedIn && (
        <div className="mt-3 pt-3 border-t border-border flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-primary animate-pulse" />
          <p className="text-xs text-primary font-medium">Session active — tap Clock Out when you leave</p>
        </div>
      )}
    </div>
  );
}